module.exports = __webpack_public_path__ + "media/images/homes/FinalHomeBanner-3c128d61849dc266238c31ae3b59212f.svg";